import PropTypes from 'prop-types';
import React from 'react';

import * as BackstageConstants from '../../../constants';
import * as D from '../../../deps';

// @ts-expect-error TS(7006) FIXME: Parameter 'props' implicitly has an 'any' type.
const ArtistBio = props => {
  const { pandoraId, bio, shareableUrlPath, isMobileDevice, shortTextWidthRatio } = props;

  if (!bio) return null;

  const linkUrl = shareableUrlPath ? D.getBackstageFullBioPathForShareUrl(shareableUrlPath) : null;

  return (
    <D.ContentSection isBio={true}>
      <D.DescriptionBackstageWithLogger
        // @ts-expect-error TS(2322) FIXME: Type '{ text: any; linkUrl: string | null; pandora... Remove this comment to see the full error message
        text={bio}
        linkUrl={linkUrl}
        pandoraId={pandoraId}
        linkText={BackstageConstants.messages.readMore}
        disableHover={isMobileDevice}
        isExpanded={false}
        shortTextWidthRatio={shortTextWidthRatio}
      />
    </D.ContentSection>
  );
};

ArtistBio.propTypes = {
  bio: PropTypes.string,
  isMobileDevice: PropTypes.bool,
  pandoraId: PropTypes.string,
  shareableUrlPath: PropTypes.string,
  shortTextWidthRatio: PropTypes.number,
};

export default ArtistBio;
